<template>
  <router-view />
</template>
<script>
import { onMounted } from "vue";
import { useStore } from "vuex";
import { tracker } from "@/main";

export default {
  name: "App",
  setup() {
    const store = useStore();

    onMounted(() => {
      const url = new URL(window.location.href);
      const shouldResetPopup = url.searchParams.get("popupReset") === "1";

      if (shouldResetPopup) {
        store.commit("setInfoPopUp", null);
        localStorage.removeItem("integratedPopupState");
      }

      const integratedUserVuex = JSON.parse(
        localStorage.getItem("integratedUserVuex"),
      );
      const userInfo = integratedUserVuex?.userInfo;
      const userName = userInfo?.userName;
      if (userName) {
        tracker.setUserID(userName);
      }
    });
  },
};
</script>
<style lang="scss"></style>
